module.exports = __webpack_public_path__ + "static/media/Rec2.1016fcd4.png";